const getPromptFrequency = (treatmentValue?: string) => {
  // The Split treatment value is a string like "on-2", "on-5" or "off"
  try {
    const regex = /^on-(\d+)$/;
    const match = treatmentValue?.match(regex);
    if (match) {
      return parseInt(match[1], 10);
    }
  } catch (_e) {
    /* gracefully handle error with default value */
  }
  return 2;
};

export default getPromptFrequency;
